import { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';

import { getAxis } from '#/redux/modules/scroll/selectors';
import getResolution from '#/utils/getResolution';

const isElementVisible = element => {
  const { height: viewportHeight } = getResolution();
  const { top: elementTop } = element.getBoundingClientRect();
  return elementTop > 0 && elementTop < viewportHeight;
};

function useIsVisible() {
  const elementRef = useRef(null);
  const scrollAxis = useSelector(getAxis);
  const [isVisible, toggleVisibility] = useState(false);
  const updateVisibility = useCallback(() => {
    if (!elementRef.current) {
      return;
    }

    toggleVisibility(isElementVisible(elementRef.current));
  }, []);

  const setRef = useCallback(node => {
    if (node === null) {
      return;
    }

    elementRef.current = node;
    toggleVisibility(isElementVisible(node));
  }, []);

  useEffect(updateVisibility, [scrollAxis]);

  return [isVisible, setRef, updateVisibility];
}

export default useIsVisible;
